const pauseVideos = () => {
  var videos = document.querySelectorAll('video');
  Array.prototype.forEach.call(videos, function (video) {
    video.pause();
  });

  var iframes = document.querySelectorAll('iframe.videoIframe');
  Array.prototype.forEach.call(iframes, (iframe) => {
    let command = {
      event: 'command',
      func: 'pauseVideo',
      method: 'pause',
    };
    iframe.contentWindow.postMessage(JSON.stringify(command), '*');
  });
};

export default pauseVideos;
